import { Space } from 'antd';
import { type PageTypes } from '..';
import EmailIcon from '../../../../assets/ci/profile/email.svg';
import PhoneIcon from '../../../../assets/ci/profile/phone.svg';
import { useAccount } from '../../../../components/contexts/AccountContextManager';
import ProfileCard from '../../../../components/ProfileCard';
import { ProfileCardWrapper } from '../styled';
import UserSelfMenuItems from '../UserSelfMenuItems';
import ContactItem from './ContactItem';

type ViewProfileContentProps = {
    onMenuItemClicked: (pageType: PageTypes) => void;
};
const ViewProfileContent = ({ onMenuItemClicked }: ViewProfileContentProps) => {
    const user = useAccount();

    if (!user) {
        return null;
    }

    const email = <ContactItem icon={<EmailIcon />} title={user.email} />;
    const phone = <ContactItem icon={<PhoneIcon />} title={`+${user.mobile.prefix} ${user.mobile.value}`} />;

    return (
        <>
            <ProfileCardWrapper>
                <ProfileCard
                    extra={
                        <Space
                            direction="vertical"
                            size={10}
                            style={{ width: '100%', textAlign: 'center', paddingTop: '16px' }}
                        >
                            {email}
                            {phone}
                        </Space>
                    }
                />
            </ProfileCardWrapper>
            <UserSelfMenuItems onMenuItemClicked={onMenuItemClicked} />
        </>
    );
};

export default ViewProfileContent;
